import { generateUUID } from "@/src/shared/utils/uuid";
import { setLayoutScrollbarsVisibility } from "@/src/shared/utils/layout";

class EasyDialogStore {
  private static instance: EasyDialogStore = new EasyDialogStore();
  private dialogStates: { [uuid: string]: { isOpened: boolean; hideBodyScrollbar: boolean } } = {};

  private constructor() {}

  static getInstance(): EasyDialogStore {
    return EasyDialogStore.instance;
  }

  public registerNewDialog({
    isOpened,
    hideBodyScrollbar = true,
  }: {
    isOpened: boolean;
    hideBodyScrollbar?: boolean;
  }): string {
    const dialogUuid = this.generateNewDialogUuid();
    this.dialogStates[dialogUuid] = { isOpened, hideBodyScrollbar };
    this.processHideBodyScrollbar(dialogUuid);
    return dialogUuid;
  }

  public updateDialogOpened(dialogUuid: string, opened: boolean) {
    if (!this.dialogStates[dialogUuid]) throw new Error(`Dialog with UUID ${dialogUuid} not found`);

    this.dialogStates[dialogUuid].isOpened = opened;
    this.processHideBodyScrollbar(dialogUuid);
  }

  private generateNewDialogUuid(): string {
    return generateUUID();
  }

  private processHideBodyScrollbar(dialogUuid: string) {
    if (!this.dialogStates[dialogUuid].hideBodyScrollbar) return;

    const allDialogsAreClosed = !Object.values(this.dialogStates).some(({ isOpened }) => isOpened);
    setLayoutScrollbarsVisibility(allDialogsAreClosed);
  }
}

export default EasyDialogStore.getInstance();
